import { Box, Divider, Grid, IconButton, Typography } from '@mui/material';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { useEffect, useMemo, useState } from 'react';
import InfoPopup, { DetailItem } from './InfoPopup';

const addressOf = person =>
  `${person?.addresses?.[0]?.street || ''} ${person?.addresses?.[0]?.city || ''} ${person?.addresses?.[0]?.state || ''} ${person?.addresses?.[0]?.zip || ''}`.trim();

export default function SiblingInfoPopup({ open, onClose, siblings, siblingInfo }) {
  const { t } = useTranslation();

  const list = useMemo(
    () => (Array.isArray(siblings) ? siblings.filter(Boolean) : siblings ? [siblings] : []),
    [siblings],
  );

  const [index, setIndex] = useState(0);

  useEffect(() => {
    setIndex(0);
  }, [list, open]);

  const sibling = list[index];
  const primaryParent = sibling?.person?.contacts?.[0]?.contact;
  const secondaryParent = sibling?.person?.contacts?.[1]?.contact;
    console.log('sibling', siblingInfo)


  return (
    <InfoPopup
      open={open}
      onClose={onClose}
      title={t('Sibling Information')}
      emptyMessage={t('No Match For Sibling:') + ' ' + siblingInfo?.siblingFirstName + ' ' + siblingInfo?.siblingLastName + ' ' + t('(Grade {{grade}})', { grade: siblingInfo?.siblingGrade })}
      hasData={list.length > 0}
    >
      {list.length > 1 && (
        <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
          <IconButton
            size="small"
            aria-label={t('Previous result')}
            onClick={() => setIndex(i => Math.max(0, i - 1))}
            disabled={index === 0}
          >
            <ChevronLeft />
          </IconButton>
          <Typography variant="body2" fontWeight={600} color="text.secondary">
            {t('Sibling {{current}} of {{total}}', { current: index + 1, total: list.length })}
          </Typography>
          <IconButton
            size="small"
            aria-label={t('Next result')}
            onClick={() => setIndex(i => Math.min(list.length - 1, i + 1))}
            disabled={index === list.length - 1}
          >
            <ChevronRight />
          </IconButton>
        </Box>
      )}

      <Grid container spacing={1}>
        <Grid item xs={12} sm={6}>
          <DetailItem
            label={t('Sibling Name')}
            value={`${sibling?.person?.firstName || '—'} ${sibling?.person?.lastName || ''}`}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <DetailItem label={t('Sibling Grade')} value={sibling?.academicYearEnrollment?.gradeLevelId} />
        </Grid>

        <Grid item xs={12}>
          <Divider />
        </Grid>

        <Grid item xs={12}>
          <Typography variant="body2" fontWeight={600} color="text.secondary">
            {t('Primary Parent/Guardian Information')}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={3}>
          <DetailItem
            label={t('Full Name')}
            value={`${primaryParent?.firstName || '—'} ${primaryParent?.lastName || ''}`}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <DetailItem label={t('Email')} value={primaryParent?.email} />
        </Grid>
        <Grid item xs={12} sm={4}>
          <DetailItem label={t('Address')} value={addressOf(primaryParent)} />
        </Grid>

        <Grid item xs={12}>
          <Typography variant="body2" fontWeight={600} color="text.secondary">
            {t('Secondary Parent/Guardian Information')}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={3}>
          <DetailItem
            label={t('Full Name')}
            value={`${secondaryParent?.firstName || '—'} ${secondaryParent?.lastName || ''}`}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <DetailItem label={t('Email')} value={secondaryParent?.email} />
        </Grid>
        <Grid item xs={12} sm={4}>
          <DetailItem label={t('Address')} value={addressOf(secondaryParent)} />
        </Grid>
      </Grid>
    </InfoPopup>
  );
}
